import { withTranslation } from "react-i18next";
import WithRouter from "../../../../components/Common/WithRouter";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { get, includes } from "lodash";
import { request } from "../../../../utils/Request";

const ModelDetail = (props: any) => {
    const { t, toastify, params } = props;
    const [entity, setEntity] = useState<any>(null);

    const getLinkInfo = (item: any) => {
        const sourceLinks = Array.isArray(item?.source_links) ? item.source_links : [];
        const providers = Array.from(new Set(
            sourceLinks
                .map((row: any) => row?.provider?.slug || row?.provider?.title || row?.provider_id)
                .filter(Boolean)
        ));
        const linkedProviders = providers;

        return {
            linked: !!item?.is_source_linked || linkedProviders.length > 0,
            providers: linkedProviders,
        };
    };

    const getDetail = async (id: string) => {
        try {
            const response = await request({
                url: `/suppliers/models/${ id }`
            });

            const { data } = response.data;
            setEntity(data);
        } catch (error) {
            toastify(t("server error"), "error");
        }
    };

    useEffect(() => {
        if ( includes(['detail'], get(params, ['operation'])) ) {
            getDetail(params.operationId);
        }
    }, [params]);

    return (
        <div className={ "p-4 bg-white" }>
            {
                entity &&
              <>
                  {
                      (() => {
                          const info = getLinkInfo(entity);
                          if ( !info.linked ) {
                              return null;
                          }
                          return (
                              <Row className="mb-2">
                                  <Col sm="12">
                                      <div className="p-2 border-round bg-orange-50 text-800">
                                          <i className="pi pi-exclamation-triangle me-2" />
                                          This record is connected with provider data.
                                          { info.providers.length > 0 &&
                                              <div className="mt-1"><small>Connected providers: { info.providers.join(', ') }</small></div> }
                                      </div>
                                  </Col>
                              </Row>
                          );
                      })()
                  }
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('brand') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ entity.brand.title }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('model name') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ entity.title	 }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('version code') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ entity.version_code }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('height') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ entity.height }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('width') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ entity.width }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('length') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ entity.length }</div>
                      </Col>
                  </Row>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('description') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ entity.description }</div>
                      </Col>
                  </Row>
              </>
            }
        </div>
    );
};

ModelDetail.propTypes = {
    // t: PropTypes.any,
};

export default withTranslation()(WithRouter(ModelDetail));
